import React from "react";
import { Scope } from "informed";
import { TextInput, DestinationPicker } from "../../shared/Forms";
import parseAppKey from "../../../helpers/routeHelpers/parseAppKey";
import PropTypes from "prop-types";

const LocationInputs = props => {
	const { index } = props;

	return (
		<Scope scope={`locations[${index}]`}>
			<TextInput field="name" id="name" placeholder="Location Name" isRequired />
			<DestinationPicker field="destination" id="destination" placeholder="destination" appKey={parseAppKey()} />
		</Scope>
	);
};

LocationInputs.propTypes = {
	index: PropTypes.number,
};

export default LocationInputs;
